// extracted by mini-css-extract-plugin
export default {"base":"base--9echq","inner":"inner--9echq"};